import Grid from "@mui/material/Grid";
import { Container } from "@mui/system";
import { useState } from "react";
import imgVerriere from "../../src/assets/images/activites/Vitaleau-Montage-Enfants.webp";
// import imgVerriere from "../assets/images/piscines/VitalEau-Lieu-7.jpg";
import { GoPloof } from "../components/organisms/GoPloof";
import PlanningModule from "../components/organisms/PlanningModule";
import MetaMaster from "../components/utils/MetaMaster";
import { Button } from "../stories/atoms/Button";
import { HeroInner } from "../stories/organisms/HeroInner";

export default function Planning() {
    const [arianeItem] = useState([
        ["/", "Vital'Eau"],
        ["/Planning", "Planning"],
    ]);

    return (
        <>
            <MetaMaster title={"Vital'eau - Planning"} />
            <HeroInner arianeItem={arianeItem} imagesSwiper={[imgVerriere]} />
            <section className="section-show-pool-home" id="accueil-histoire">
                <Container maxWidth="xl">
                    <Grid container>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <div>
                                <h1 className="accueil-histoire-titre h1-inner" data-title="Planning 2026/2027">
                                    Planning 2026/2027
                                </h1>
                                <p id="accueil-histoire-baseline"></p>
                                <p className="text-center">
                                    La piscine Vital’Eau est ouverte du lundi au dimanche, avec un planning adapté au mieux au quotidien de chacun.
                                </p>
                            </div>
                        </Grid>
                    </Grid>
                </Container>
            </section>
            <section className="section-planning-iframe">
                <Container maxWidth="xl">
                    <Grid container>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <div className="section-planning-iframe-inner">
                                <p>
                                    Les créneaux adultes "heures creuses"sont marqués par un astérisque. <br />
                                    <br />
                                    Lors des vacances scolaires et jours fériés, le planning peut varier selon la demande.
                                </p>
                            </div>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <PlanningModule />
                        </Grid>
                    </Grid>
                </Container>
            </section>
            {/* <Container maxWidth="xl" className="pt124">
                <Grid container>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Alert severity="warning">
                            Pour consulter notre planning, n'hésitez pas à vous inscrire gratuitement en cliquant sur le lien{" "}
                            <a
                                href="https://member.resamania.com/vitaleau-aquaboulevard/"
                                target="_blank"
                                style={{
                                    textDecoration: "underline",
                                    display: "initial",
                                }}
                                rel="noreferrer"
                            >
                                <strong>ICI</strong>
                            </a>
                            .
                        </Alert>
                    </Grid>
                </Grid>
            </Container> */}
            <GoPloof />
            <section className="section-contact">
                <Container maxWidth="xl">
                    <Grid container>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <div>
                                <h2 className="accueil-histoire-titre" data-title="Des questions ?">
                                    Des questions ?
                                </h2>
                                <p className="text-center">
                                    Besoin d’informations ? Envie d’en savoir plus sur nos activités et notre fonctionnement ? <br />
                                    Nous sommes disponibles pour répondre à toutes vos demandes !
                                </p>
                                <br />
                                <br />
                                <Button label="Nous contacter" style={{ width: "fit-content", margin: "0 auto" }} primary href={"/contact"} />
                            </div>
                        </Grid>
                    </Grid>
                </Container>
            </section>
        </>
    );
}
